/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SMRuleListItem
 */
export interface SMRuleListItem {
    /**
     * 
     * @type {string}
     * @memberof SMRuleListItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SMRuleListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SMRuleListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SMRuleListItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SMRuleListItem
     */
    comment?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SMRuleListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof SMRuleListItem
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof SMRuleListItem
     */
    readonly suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {number}
     * @memberof SMRuleListItem
     */
    relevance?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SMRuleListItem
     */
    allowEdit?: boolean;
}

export function SMRuleListItemFromJSON(json: any): SMRuleListItem {
    return SMRuleListItemFromJSONTyped(json, false);
}

export function SMRuleListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMRuleListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function SMRuleListItemToJSON(value?: SMRuleListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'deleted': value.deleted,
        'description': value.description,
        'comment': value.comment,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'relevance': value.relevance,
        'allowEdit': value.allowEdit,
    };
}


